<template>
<div>
    <v-layout>
        <v-flex xs12>
            <img src="../../../assets/bitacorapp-logo.png" width="320" alt="">
        </v-flex>
    </v-layout>
    <v-layout>
        <v-flex xs12>
            <v-text-field
                required 
                v-model="email"
                placeholder="E-mail"
                @input="$v.email.$touch()"
                :error-messages="errors.email"
            ></v-text-field>
        </v-flex>
    </v-layout>
    <v-layout>
        <v-flex xs12>
            <v-btn color="success" @click="resetPassword">Restablecer contraseña</v-btn>
        </v-flex>
    </v-layout>  
</div>
</template>

<script>
import authRepository from '../../../repositories/auth.repository.js'; 
import { required, email } from 'vuelidate/lib/validators';
export default {
    data(){
        return {
            email: ''
        }
    },
    validations: {
            email: {required, email},
    },
    computed: {
        errors() {
            return {
                email: this.$v.email.$error? ['Debe escribir un E-mail valido']: [],
            }
        }
    },
    methods:{
        resetPassword(){
            this.$v.$touch();

            if(this.$v.$invalid) return;

            this.startProcessing();

            const payload = {email: this.email};

            const ar = {...authRepository};
            ar.recoverPassword(payload)
            .then(resp =>{
                this.stopProcessing();
                    const status = resp.data;

                    if(!!status.status){
                        toastr.success(status.msg, {
                            timeout: 6000
                        });
                        this.email = '';
                        this.$router.push({ name: 'login' });
                    } else {
                        toastr.error(status.msg);
                    }
            })
            .catch(error => {
                this.stopProcessing();
                    toastr.error('Error al enviar petición');
            });
        }

    }
}
</script>




// WEBPACK FOOTER //
// src/pages/Login/RecoverPassword/RecoverPassword.vue